export const specialAddresses = {
  uk: [
    {
      id: 'prg-airport-t1',
      firstName: 'Термінал 1',
      name: 'Аеропорт Вацлава Гавела Прага',
      formatted_address: 'Термінал 1 - Аеропорт Вацлава Гавела Прага',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Термінал 2',
      name: 'Аеропорт Вацлава Гавела Прага',
      formatted_address: 'Термінал 2 - Аеропорт Вацлава Гавела Прага',
    },
    {
      id: 'prg-main-station',
      firstName: 'Головний вокзал',
      name: 'Прага Головний вокзал',
      formatted_address:
        'Прага Головний вокзал, Wilsonova 300/8, 110 00 Прага 1',
    },
  ],
  en: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminal 1',
      name: 'Václav Havel Airport Prague',
      formatted_address: 'Terminal 1 - Václav Havel Airport Prague',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminal 2',
      name: 'Václav Havel Airport Prague',
      formatted_address: 'Terminal 2 - Václav Havel Airport Prague',
    },
    {
      id: 'prg-main-station',
      firstName: 'Main Train Station',
      name: 'Prague Main Train Station',
      formatted_address:
        'Prague Main Train Station, Wilsonova 300/8, 110 00 Prague 1',
    },
  ],
  cs: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminal 1',
      name: 'Letiště Václava Havla Praha',
      formatted_address: 'Terminal 1 - Letiště Václava Havla Praha',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminal 2',
      name: 'Letiště Václava Havla Praha',
      formatted_address: 'Terminal 2 - Letiště Václava Havla Praha',
    },
    {
      id: 'prg-main-station',
      firstName: 'Hlavní nádraží',
      name: 'Praha hlavní nádraží',
      formatted_address:
        'Praha hlavní nádraží, Wilsonova 300/8, 110 00 Praha 1',
    },
  ],
  sk: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminál 1',
      name: 'Letisko Václava Havla Praha',
      formatted_address: 'Terminál 1 - Letisko Václava Havla Praha',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminál 2',
      name: 'Letisko Václava Havla Praha',
      formatted_address: 'Terminál 2 - Letisko Václava Havla Praha',
    },
    {
      id: 'prg-main-station',
      firstName: 'Hlavná stanica',
      name: 'Praha hlavná stanica',
      formatted_address:
        'Praha hlavná stanica, Wilsonova 300/8, 110 00 Praha 1',
    },
  ],
  de: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminal 1',
      name: 'Flughafen Václav Havel Prag',
      formatted_address: 'Terminal 1 - Flughafen Václav Havel Prag',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminal 2',
      name: 'Flughafen Václav Havel Prag',
      formatted_address: 'Terminal 2 - Flughafen Václav Havel Prag',
    },
    {
      id: 'prg-main-station',
      firstName: 'Hauptbahnhof',
      name: 'Prag Hauptbahnhof',
      formatted_address: 'Prag Hauptbahnhof, Wilsonova 300/8, 110 00 Prag 1',
    },
  ],
  fr: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminal 1',
      name: 'Aéroport Václav Havel Prague',
      formatted_address: 'Terminal 1 - Aéroport Václav Havel Prague',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminal 2',
      name: 'Aéroport Václav Havel Prague',
      formatted_address: 'Terminal 2 - Aéroport Václav Havel Prague',
    },
    {
      id: 'prg-main-station',
      firstName: 'Gare principale',
      name: 'Gare principale de Prague',
      formatted_address:
        'Gare principale de Prague, Wilsonova 300/8, 110 00 Prague 1',
    },
  ],
  es: [
    {
      id: 'prg-airport-t1',
      firstName: 'Terminal 1',
      name: 'Aeropuerto Václav Havel Praga',
      formatted_address: 'Terminal 1 - Aeropuerto Václav Havel Praga',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Terminal 2',
      name: 'Aeropuerto Václav Havel Praga',
      formatted_address: 'Terminal 2 - Aeropuerto Václav Havel Praga',
    },
    {
      id: 'prg-main-station',
      firstName: 'Estación Central',
      name: 'Estación Central de Praga',
      formatted_address:
        'Estación Central de Praga, Wilsonova 300/8, 110 00 Praga 1',
    },
  ],
  zh: [
    {
      id: 'prg-airport-t1',
      firstName: '1号航站楼',
      name: '布拉格瓦茨拉夫·哈维尔机场',
      formatted_address: '1号航站楼 - 布拉格瓦茨拉夫·哈维尔机场',
    },
    {
      id: 'prg-airport-t2',
      firstName: '2号航站楼',
      name: '布拉格瓦茨拉夫·哈维尔机场',
      formatted_address: '2号航站楼 - 布拉格瓦茨拉夫·哈维尔机场',
    },
    {
      id: 'prg-main-station',
      firstName: '中央火车站',
      name: '布拉格中央火车站',
      formatted_address: '布拉格中央火车站, Wilsonova 300/8, 110 00 布拉格1',
    },
  ],
  ru: [
    {
      id: 'prg-airport-t1',
      firstName: 'Терминал 1',
      name: 'Аэропорт Вацлава Гавела Прага',
      formatted_address: 'Терминал 1 - Аэропорт Вацлава Гавела Прага',
    },
    {
      id: 'prg-airport-t2',
      firstName: 'Терминал 2',
      name: 'Аэропорт Вацлава Гавела Прага',
      formatted_address: 'Терминал 2 - Аэропорт Вацлава Гавела Прага',
    },
    {
      id: 'prg-main-station',
      firstName: 'Главный вокзал',
      name: 'Прага Главный вокзал',
      formatted_address:
        'Прага Главный вокзал, Wilsonova 300/8, 110 00 Прага 1',
    },
  ],
};
